import * as luxon from 'luxon';
import { IdentityProvider } from '@whizz/react-identity';
import React from 'react';
import type Identity from '@whizz/api-client/dist/@types/model/Identity';
import type Teacher from '@whizz/api-client/dist/@types/model/Teacher';
import { useMixpanel } from 'react-mixpanel-browser';
import { model } from '@whizz/api-client';
import { useI18n } from '@whizz/react-i18n';
import { DEFAULT_LOCALE_ID } from './App';
import { PUBLIC_PATHS } from '../util/constants';
import { ROUTES } from '../util/vars';

const authorizer = (identity: Identity, me: unknown | Teacher) => {
  if (me instanceof model.Teacher) {
    return Promise.resolve();
  }

  return Promise.reject(new Error('User not authenticated or is of invalid type'));
};

const IdentityProviderWrapper = ({ children, ...rest }: Props) => {
  const { locale } = useI18n();
  const mixpanel = useMixpanel();

  if (PUBLIC_PATHS.includes(location.pathname) || location.pathname.indexOf(ROUTES.superAdmin) !== -1) {
    return children;
  }

  return (
    <IdentityProvider
      {...rest}
      authorizer={authorizer}
      idleTimeout={1200}
      loadingComponent={() => <div>Loading...</div>}
      logoutParams={{ locale: locale ? locale.getId() : DEFAULT_LOCALE_ID }}
      luxon={luxon}
      mixpanel={process.env.REACT_APP_MIXPANEL_TOKEN?.length ? mixpanel : null}
    >
      {children as JSX.Element}
    </IdentityProvider>
  );
};

export default IdentityProviderWrapper;

interface Props extends Record<string, any> {
  children: React.ReactElement;
}
